<template>
  <ShopBanner v-if="ConfigShowShopBanner"/>
  <v-app id="layout-app">
    <v-app-bar density="comfortable" :color="ConfigTopbarColor" :elevation="0" class="border-b">
      <v-app-bar-nav-icon variant="text" @click.stop="drawer=!drawer"/>
      <v-spacer/>
      <HelperIcon/>
      <CopierCart/>
      <div class="ml-3 mr-3"></div>
      <Branding/>
    </v-app-bar>
    <v-navigation-drawer width="300" v-model="drawer" location="left" :z-index="300" style="z-index: 300 !important;">
      <v-card elevation="0" class="filter-drawer-card pa-4">
        <v-card-text class="pa-2">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="SearchBox"
            class="search-box mb-4"
            variant="outlined"
            bg-color="#F8F8F8"
            density="compact"
            label="Search"
            type="search"
            rounded="lg">
          </v-text-field>

          <FilterItem :hide-button="true">
            <template #title>
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="filters-header-title">Filters</div>
                <div>
                  <v-btn
                    text="Reset"
                    size="x-small"
                    class="d-flex filter-reset-btn"
                    rounded="pill"
                    variant="text"
                    @click="ResetFilters"
                    v-if="HasActiveFilters"
                    prepend-icon="mdi-restart">
                  </v-btn>
                </div>
              </div>
            </template>
            <FilterTags/>
          </FilterItem>

          <template v-if="show_office_size">
            <v-divider/>
            <FilterItem title="Office Size">
              <CustomCheckbox
                label="1–10 people"
                :is_checked="ItemExists('office_sizes', '1-10')"
                @CheckChange="SetAnyFilter($event, 'office_sizes', '1-10')">
              </CustomCheckbox>
              <CustomCheckbox
                label="10–25 people"
                :is_checked="ItemExists('office_sizes', '10-25')"
                @CheckChange="SetAnyFilter($event, 'office_sizes', '10-25')">
              </CustomCheckbox>
              <CustomCheckbox
                label="25–50 people"
                :is_checked="ItemExists('office_sizes', '25-50')"
                @CheckChange="SetAnyFilter($event, 'office_sizes', '25-50')">
              </CustomCheckbox>
              <CustomCheckbox
                label="50+ people"
                :is_checked="ItemExists('office_sizes', '50+')"
                @CheckChange="SetAnyFilter($event, 'office_sizes', '50+')">
              </CustomCheckbox>
            </FilterItem>
          </template>

          <template v-if="show_print_volume">
            <v-divider/>
            <FilterItem title="Print Volume / Month">
              <CustomCheckbox
                label="Less than 3,000"
                :is_checked="ItemExists('print_volumes', '<3000')"
                @CheckChange="SetAnyFilter($event, 'print_volumes', '<3000')">
              </CustomCheckbox>
              <CustomCheckbox
                label="3,000–10,000"
                :is_checked="ItemExists('print_volumes', '3000-10000')"
                @CheckChange="SetAnyFilter($event, 'print_volumes', '3000-10000')">
              </CustomCheckbox>
              <CustomCheckbox
                label="10,000+"
                :is_checked="ItemExists('print_volumes', '10000+')"
                @CheckChange="SetAnyFilter($event, 'print_volumes', '10000+')">
              </CustomCheckbox>
            </FilterItem>
          </template>

          <template v-if="show_manufacturer">
            <v-divider/>
            <FilterItem title="Manufacturer">
              <CustomCheckbox
                :key="make.id"
                :label="make.name"
                v-for="make in DisplayedManufacturers"
                :is_checked="ItemExists('manufacturers',+make.id)"
                @CheckChange="SetAnyFilter($event,'manufacturers',+make.id)">
              </CustomCheckbox>
              <v-btn
                block
                rounded="lg"
                color="primary"
                variant="outlined"
                density="comfortable"
                class="mt-2 text-none font-weight-bold"
                @click="show_all_brands = !show_all_brands"
                v-if="ActiveManufacturers.length > INITIAL_BRAND_LIMIT">
                {{ show_all_brands ? 'Show fewer brands' : 'Show all brands' }}
              </v-btn>
            </FilterItem>
          </template>

          <template v-if="show_intended_use">
            <v-divider/>
            <FilterItem title="Intended Use">
              <CustomCheckbox
                :key="level"
                :label="level"
                v-for="level in usage_levels"
                :is_checked="ItemExists('usage_levels',level)"
                @CheckChange="SetAnyFilter($event,'usage_levels',level)">
              </CustomCheckbox>
            </FilterItem>
          </template>

          <template v-if="show_copier_color">
            <v-divider/>
            <FilterItem title="Mono or Color">
              <CustomCheckbox
                label="Color"
                :is_checked="ItemExists('copier_colors','Color')"
                @CheckChange="SetAnyFilter($event,'copier_colors','Color')">
              </CustomCheckbox>
              <CustomCheckbox
                label="Mono"
                :is_checked="ItemExists('copier_colors','B&W')"
                @CheckChange="SetAnyFilter($event,'copier_colors','B&W')">
              </CustomCheckbox>
            </FilterItem>
          </template>

          <template v-if="show_form_factor">
            <v-divider/>
            <FilterItem title="Form Factor">
              <CustomCheckbox
                :key="form_factor"
                :label="form_factor"
                v-for="form_factor in form_factors"
                :is_checked="ItemExists('form_factors',form_factor)"
                @CheckChange="SetAnyFilter($event,'form_factors',form_factor)">
              </CustomCheckbox>
            </FilterItem>
          </template>

          <template v-if="show_capabilities">
            <v-divider/>
            <FilterItem title="Capabilities">
              <CustomCheckbox
                :key="capability"
                :label="capability"
                v-for="capability in capabilities"
                :is_checked="ItemExists('capabilities',capability)"
                @CheckChange="SetAnyFilter($event,'capabilities',capability)">
              </CustomCheckbox>
            </FilterItem>
          </template>

          <template v-if="show_connectivity">
            <v-divider/>
            <FilterItem title="Connectivity">
              <CustomCheckbox
                :key="connection"
                :label="connection"
                v-for="connection in connection_types"
                :is_checked="ItemExists('connection_types',connection)"
                @CheckChange="SetAnyFilter($event,'connection_types',connection)">
              </CustomCheckbox>
            </FilterItem>
          </template>

          <template v-if="show_print_speed">
            <v-divider/>
            <FilterItem title="Print Speed (PPM)">
              <div class="d-flex align-center gap-2 mt-2">
                <v-text-field
                  min="0"
                  max="200"
                  type="number"
                  hide-details
                  rounded="lg"
                  placeholder="Min"
                  bg-color="#F8F8F8"
                  density="compact"
                  variant="outlined"
                  v-model.number="SpeedMinimum">
                </v-text-field>
                <span class="speed-separator text-slate-400 font-weight-bold mx-1">-</span>
                <v-text-field
                  min="0"
                  max="200"
                  type="number"
                  hide-details
                  rounded="lg"
                  placeholder="Max"
                  bg-color="#F8F8F8"
                  density="compact"
                  variant="outlined"
                  v-model.number="SpeedMaximum">
                </v-text-field>
              </div>
            </FilterItem>
          </template>

          <template v-if="show_paper_size">
            <v-divider/>
            <FilterItem title="Paper Size">
              <CustomCheckbox
                :key="paper_size"
                :label="paper_size"
                v-for="paper_size in paper_sizes"
                :is_checked="ItemExists('paper_sizes',paper_size)"
                @CheckChange="SetAnyFilter($event,'paper_sizes',paper_size)">
              </CustomCheckbox>
            </FilterItem>
          </template>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
    <v-main>
      <v-card-text class="pa-1 pa-sm-3 pa-md-5" style="background:#e8e8e8">
        <slot name="content"/>
      </v-card-text>
      <div class="d-flex" v-if="$slots.footer" style="background:#f1f1f1" elevation="1">
        <slot name="footer"/>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import { FilterProductByTab, type CategoryTabKey } from '@/mixins/CategoryMixins.ts'

// Imported Components
import ShopBanner from "@/components/catalog/ShopBanner.vue"
import CopierCart from "@/components/cart/CopierCart.vue"
import HelperIcon from "@/components/configurator/HelperIcon.vue"
import CustomCheckbox from "@/components/misc/CustomCheckbox.vue"
import FilterTags from "@/components/catalog/FilterTags.vue"
import FilterItem from "@/components/catalog/FilterItem.vue"
import Branding from "@/components/misc/Branding.vue"

// Global Store
const store = useGlobalsStore()
const {
  filters,
  manufacturers,
  manufacturers_allowed,
  paper_sizes,
  usage_levels,
  form_factors,
  capabilities,
  connection_types,
  ConfigTopbarColor,
  ConfigShowShopBanner,
  config_drawer,
  is_mobile,
  products
} = storeToRefs(store)

// Component State
const drawer = ref(true)

// Category Tab & Visibility State
const current_tab = computed<CategoryTabKey>(() => {
  const tab = filters.value.category_tab as CategoryTabKey
  return (tab === 'office-copiers' || !tab) ? 'printers' : tab
})

const is_printer_or_copier = computed(() => current_tab.value === 'printers')
const is_scanner = computed(() => current_tab.value === 'scanners')
const is_phone = computed(() => current_tab.value === 'phones')

const show_office_size = computed(() => is_printer_or_copier.value)
const show_print_volume = computed(() => is_printer_or_copier.value)
const show_manufacturer = computed(() => true)
const show_intended_use = computed(() => is_printer_or_copier.value || is_scanner.value)
const show_copier_color = computed(() => is_printer_or_copier.value || is_scanner.value)
const show_form_factor = computed(() => is_printer_or_copier.value || is_scanner.value)
const show_capabilities = computed(() => is_printer_or_copier.value)
const show_connectivity = computed(() => is_printer_or_copier.value || is_scanner.value || is_phone.value)
const show_print_speed = computed(() => is_printer_or_copier.value)
const show_paper_size = computed(() => is_printer_or_copier.value || is_scanner.value)

const ActiveManufacturers = computed(() => {
  const current_tab_products = products.value.filter(p => FilterProductByTab(p, current_tab.value))
  const product_manufacturer_ids = new Set(current_tab_products.map(p => Number(p.manufacturer_id)))
  return manufacturers.value.filter(man =>
    (manufacturers_allowed.value.length === 0 || manufacturers_allowed.value.includes(Number(man.id))) &&
    product_manufacturer_ids.has(Number(man.id))
  )
})

const show_all_brands = ref(false)
const INITIAL_BRAND_LIMIT = 6

const DisplayedManufacturers = computed(() => {
  if (show_all_brands.value || ActiveManufacturers.value.length <= INITIAL_BRAND_LIMIT) {
    return ActiveManufacturers.value
  }
  const initial = ActiveManufacturers.value.slice(0, INITIAL_BRAND_LIMIT)
  const checked_others = ActiveManufacturers.value.slice(INITIAL_BRAND_LIMIT).filter(m =>
    ItemExists('manufacturers', +m.id)
  )
  return [...initial, ...checked_others]
})

watch(current_tab, () => {
  show_all_brands.value = false
})

// Computed
const SpeedMinimum = computed({
  get() {
    return filters.value.speed_minimum ?? ''
  },
  set(val: any) {
    const filtersCopy = { ...filters.value }
    filtersCopy.speed_minimum = val !== '' && val !== null && !isNaN(Number(val)) ? Number(val) : null
    store.SetFilters(filtersCopy)
  }
})

const SpeedMaximum = computed({
  get() {
    return filters.value.speed_maximum ?? ''
  },
  set(val: any) {
    const filtersCopy = { ...filters.value }
    filtersCopy.speed_maximum = val !== '' && val !== null && !isNaN(Number(val)) ? Number(val) : null
    store.SetFilters(filtersCopy)
  }
})

// Methods

function SetAnyFilter(is_checked: any, target: string, value: any) {
  if (typeof is_checked === 'object' && is_checked !== null && 'target' in is_checked) {
    is_checked = is_checked.target.checked
  }
  const rawFilters = { ...filters.value } as any
  const exists = rawFilters[target].find((c: any) => c == value)

  if (is_checked == true) {
    if (!exists) {
      rawFilters[target].push(value)
    }
  } else {
    if (exists) {
      const index = rawFilters[target].indexOf(value)
      if (index !== -1) {
        rawFilters[target].splice(index, 1)
      }
    }
  }
  store.SetFilters(rawFilters)
}

function ItemExists(target: string, value: any) {
  const filterList = (filters.value as any)[target] as any[]
  return filterList.includes(value)
}

function ResetFilters() {
  filters.value = {
    sort_type: null,
    page_limit: 12,
    search_input: '',
    manufacturers: [],
    device_types: [],
    copier_colors: [],
    speed_minimum: null,
    speed_maximum: null,
    price_filters: [],
    price_options: [
      { label: "$69-$99", min: 69, max: 99 },
      { label: "$100-$199", min: 100, max: 199 },
      { label: "$200+", min: 200, max: 9999 }
    ],
    paper_sizes: [],
    product_categories: [],
    form_factors: [],
    capabilities: [],
    connection_types: [],
    usage_levels: [],
    office_sizes: [],
    print_volumes: [],
    category_tab: filters.value.category_tab ?? 'printers',
  }
}

// Computed
const SearchBox = computed({
  get() {
    return filters.value.search_input
  },
  set(value) {
    store.SetFilters({
      ...filters.value,
      search_input: value
    })
  }
})

const HasActiveFilters = computed(() => {
  const { manufacturers, device_types, copier_colors, price_filters, paper_sizes, product_categories, form_factors, capabilities, connection_types, usage_levels, office_sizes, print_volumes, search_input, speed_minimum, speed_maximum } = filters.value
  return [manufacturers, device_types, copier_colors, price_filters, paper_sizes, product_categories, form_factors, capabilities, connection_types, usage_levels, office_sizes || [], print_volumes || []].some(f => f.length > 0) || !!search_input || !!speed_minimum || !!speed_maximum
})

onMounted(() => {
  const isMobile = window.innerWidth <= 768
  if (isMobile) {
    drawer.value = false
    config_drawer.value = false
    is_mobile.value = isMobile
  }
})
</script>
<style lang="scss">
#layout-app {
  .v-application__wrap {
    border-bottom: none !important;
    height: fit-content !important;
    margin-bottom: 0;
    min-height: 100vh;
    background: #f8fafc;
  }
}

.v-navigation-drawer {
  z-index: 300 !important;
}

/* Custom Scrollbar for Sidebar Drawer */
.v-navigation-drawer__content {
  height: 100% !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  scrollbar-width: thin;
  scrollbar-color: #eaeaea transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #eaeaea;
    border-radius: 20px;
    border: transparent;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #d4d4d4;
    }
  }
}

/* Sidebar Drawer Card Redesign */
.filter-drawer-card {
  font-family: 'Inter', sans-serif;
  background: #ffffff !important;
  border-right: 1px solid #f1f5f9;
  min-height: 100% !important;
  height: auto !important;
  overflow: visible !important;

  .v-card-text {
    padding: 8px 12px !important;
    overflow: visible !important;
  }

  .v-divider {
    border-color: #f1f5f9 !important;
    opacity: 0.8;
    margin: 10px 0 !important;
  }
}

/* Header Filters Title & Reset Button */
.filters-header-title {
  font-family: 'Outfit', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.filter-reset-btn {
  text-transform: none !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  padding: 0 8px !important;
  height: 24px !important;
  transition: all 0.2s ease;

  &:hover {
    color: #ef4444 !important;
    background-color: rgba(239, 68, 68, 0.08) !important;
  }
}

/* App Bar styling */
#layout-app .v-app-bar.border-b {
  border-bottom: 1px solid #f1f5f9 !important;
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.85) !important;
}

/* Search Box & Range Input border overrides */
.search-box, .filter-drawer-card .v-text-field {
  .v-field {
    border-radius: 10px !important;
    background-color: #f8fafc !important;
    transition: all 0.2s ease-in-out !important;
    border: 1px solid #e2e8f0 !important;
    box-shadow: none !important;

    .v-field__outline {
      display: none !important;
    }

    &:hover {
      background-color: #f1f5f9 !important;
      border-color: #cbd5e1 !important;
    }

    &.v-field--focused {
      background-color: #ffffff !important;
      border-color: #3b82f6 !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
    }
  }

  .v-input__details {
    display: none !important;
  }
}
</style>
